<template>
    <span>{{city}}</span>
</template>
<script>
    import {mapActions} from 'vuex'

    export default {
        props: {
            location: String,
        },
        data() {
            return {
                city: '',
                interval:''
            }
        },
        mounted() {
            var self = this;
            var s = 0;
            self.interval = setInterval(function(){
                if(self.location != 'undefined,undefined'){
                   self.getRegeo(self.location).then(res => {
                        self.city = res
                    })
                    clearInterval(self.interval);
                    self.interval = null; 
                    console.log(self.interval)
                    s++;
                }
            },1000)
            // this.getRegeo(this.location).then(res => {
            //     this.city = res
            // })
        },
        methods: {
            ...mapActions('other', ['getRegeo'])
        }
    }
</script>